// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__B3Spp","row":"styles_row__2X_8n"};